import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsCommon} from "../../shared/dto/aps.common";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface UserService {
  getUsers(plantId: string, roleId: string, includeDeleted: boolean): angular.IPromise<apsViewModels.UserListItem[]>;
  getUser(id: string): angular.IPromise<apsViewModels.UserDetail>;
  changePassword(changePassword: any): angular.IPromise<any>;
  getGeneratedUserName(id: string, firstName: string, lastName: string): angular.IPromise<string>;
  getRoles(): angular.IPromise<apsViewModels.RoleListItem[]>;
  getAssignableRoles(): angular.IPromise<apsViewModels.RoleListItem[]>;
  getSecurityQuestions(): angular.IPromise<apsViewModels.SecurityQuestionItem[]>;
  addUser(user: apsCommands.AddUser): angular.IPromise<any>;
  editUser(user: apsCommands.EditUser): angular.IPromise<any>;
  getUserProfile(): angular.IPromise<apsViewModels.UserProfileData>;
  saveUserProfile(data: apsCommands.EditUserProfile): angular.IPromise<any>;
  getUsersToNotify(): angular.IPromise<apsCommon.IdAndName[]>;
}

export default angular.module('aps.services.users', [HttpServiceName])
  .service('userService', function(httpService: HttpService): UserService {

    return {
      getUsers: getUsers,
      getUser: getUser,
      changePassword: changePassword,
      getGeneratedUserName: getGeneratedUserName,
      getRoles: getRoles,
      getAssignableRoles: getAssignableRoles,
      getSecurityQuestions: getSecurityQuestions,
      addUser: addUser,
      editUser: editUser,
      getUserProfile: getUserProfile,
      saveUserProfile: saveUserProfile,
      getUsersToNotify: getUsersToNotify
    };

    function getUsers(plantId: string, roleId: string, includeDeleted: boolean): angular.IPromise<apsViewModels.UserListItem[]> {
      return httpService.get<apsViewModels.UserListItem[]>(Endpoints.USERS, {
        plantId: plantId,
        roleId: roleId,
        includeDeleted: includeDeleted
      });
    }

    function getUsersToNotify(): angular.IPromise<apsCommon.IdAndName[]> {
      return httpService.get<apsCommon.IdAndName[]>(Endpoints.USERS_NOTIFY);
    }

    function getUser(id: string): angular.IPromise<apsViewModels.UserDetail> {
      return httpService.get<apsViewModels.UserDetail>(Endpoints.USERS + '/' + id);
    }

    function getSecurityQuestions(): angular.IPromise<apsViewModels.SecurityQuestionItem[]> {
      return httpService.get<apsViewModels.SecurityQuestionItem[]>(Endpoints.SECURITY_QUESTIONS);
    }

    function addUser(user: apsCommands.AddUser): angular.IPromise<any> {
      return httpService.post(Endpoints.USERS, user);
    }

    function editUser(user: apsCommands.EditUser): angular.IPromise<any> {
      return httpService.put(Endpoints.USERS, user);
    }

    function getUserProfile(): angular.IPromise<apsViewModels.UserProfileData> {
      return httpService.get(Endpoints.USERPROFILE);
    }

    function saveUserProfile(data: apsCommands.EditUserProfile): angular.IPromise<any> {
      return httpService.post(Endpoints.USERPROFILE, data);
    }

    function getRoles(): angular.IPromise<apsViewModels.RoleListItem[]> {
      return httpService.get<apsViewModels.RoleListItem[]>(Endpoints.ROLES);
    }

    function getAssignableRoles(): angular.IPromise<apsViewModels.RoleListItem[]> {
      return httpService.get<apsViewModels.RoleListItem[]>(Endpoints.ROLES_ASSIGNABLE);
    }

    function getGeneratedUserName(id: string, firstName: string, lastName: string): angular.IPromise<string> {
      return httpService.get<string>(Endpoints.USER_GENERATED_USERNAME + '/' + id, {
        firstName: firstName,
        lastName: lastName
      });
    }

    function changePassword(changePassword: any): angular.IPromise<any> {
      return httpService.post(Endpoints.USER_CHANGE_PASSWORD, changePassword);
    }
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/users/user.service.ts